<script setup lang="ts">
    export interface PriceProps {
        price?: string | null;
        compareAtPrice?: string | null;
        stacked?: boolean;
        alignment?: 'center' | 'right';
        size?: 'md' | 'lg';
    }

    defineProps<PriceProps>();
</script>
<template>
    <div
        :class="[
            'flex gap-1',
            { 'items-center justify-center': alignment === 'center', ' items-end justify-end': alignment === 'right', 'flex-col': stacked },
        ]">
        <span
            :class="[
                'font-sans font-bold',
                {
                    'text-2xl md:text-3xl': size === 'lg',
                    'text-lg leading-5': size === 'md',
                },
            ]">
            {{ price }}
        </span>
        <span
            class="text-woom-grey-moon line-through"
            v-if="compareAtPrice">
            <span class="sr-only">{{ $t('price.a11y.strikeprice') }}</span>
            {{ compareAtPrice }}
        </span>
    </div>
</template>
